module.exports = __webpack_public_path__ + "img/undraw_typewriter.d55bc086.svg";